export class Controller {

    /** @ngInject */
    constructor($state) {
        this.$state = $state;
    }

    $onInit() {
        this.importResult = this.$state.params.importResult;
        this.close= ()=> {
            $state.go('user.public-user-accounts', {}, {reload: true});
        }
    }
}



// WEBPACK FOOTER //
// ./src/portal/states/user/public-user-accounts/import/import-result/import-result.controller.js